/**
 * ChecklistSkeleton
 *
 * A skeleton loading state for the Checklist component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface ChecklistSkeletonProps {
  className?: string
  itemCount?: number
}

export const ChecklistSkeleton: React.FC<ChecklistSkeletonProps> = ({
  className,
  itemCount = 5
}) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center border-b p-3">
        <div className="flex items-center gap-2">
          <div className="size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>

      <div className="p-4">
        {/* Checklist items */}
        <div className="space-y-3">
          {[...Array(itemCount)].map((_, index) => (
            <div key={index} className="flex items-start gap-2">
              <div className="mt-0.5 size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="flex-1 space-y-1">
                <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
                {index % 2 === 0 && (
                  <div className="h-3 w-4/5 rounded bg-gray-200 dark:bg-gray-700"></div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Progress indicator */}
        <div className="mt-4 border-t pt-3">
          <div className="h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700">
            <div className="h-2 w-2/5 rounded-full bg-blue-400 dark:bg-blue-600"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
